<template>
	<a href class="btn-collect" @click.prevent="click">
		<i class="fa fa-star-o"></i>
		收藏 {{count}}
	</a>
</template>

<script>
export default {
	name: "Collect",
	props: ["refId", "refType", "init-num"],
	data() {
		return {
			count: this.initNum || 0
		};
	},
	methods: {
		click() {
			let user = this.$store.getters.user
			if (!user) {
				return this.util.$emit("login")
			}

			this.$message.closeAll()
			this.axios
				.get(this.axios.apiGateway + "follow/collect", {
					params: {
						token: user.token,
						refType: this.refType,
						refId: this.refId
					}
				})
				.then(res => {
					if (res.data.errcode) {
						this.$message.error(res.data.errmsg)
					} else {
						this.count = res.data.num;
						if (res.data.status) {
							this.$message.success('收藏成功！')
						} else {
							this.$message.info('取消收藏！')
						}
					}
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Collect.vue